import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const LaunchDarkly = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.1457 22C11.9773 22.0003 11.8235 21.9043 11.7494 21.7527C11.6776 21.61 11.693 21.4387 11.789 21.3111L16.4749 14.8417L8.2702 18.2022C8.21459 18.2265 8.15468 18.2393 8.09404 18.2398C7.89912 18.2388 7.72803 18.1095 7.67345 17.9218C7.61752 17.7383 7.69159 17.5399 7.85402 17.4383L15.07 13.1658L2.36441 12.4328C2.15371 12.3958 2 12.2123 2 11.9978C2 11.7833 2.15371 11.5998 2.36441 11.5628L15.0766 10.832L7.85842 6.5595C7.69599 6.4579 7.62192 6.25954 7.67786 6.07595C7.7322 5.8891 7.90214 5.75995 8.09624 5.758C8.15719 5.7578 8.21741 5.77138 8.2724 5.79775L16.4793 9.16273L11.7934 2.69552C11.6974 2.56791 11.682 2.39667 11.7538 2.25392C11.8256 2.10041 11.9788 2.00173 12.1479 2C12.2636 2.00077 12.3741 2.04858 12.454 2.13248L21.7927 11.4944C22.0691 11.7719 22.0691 12.2214 21.7927 12.499L12.4496 21.8719C12.3696 21.9539 12.2601 22 12.1457 22Z"
      fill="currentColor"
    />
  </Icon>
));

export default LaunchDarkly;
